import styled, {css} from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"

import {TROPHY_SIZE} from "../constants"

interface StyledProps {
  isTrophySelected: boolean
}

const ComponentToHideOnExpandContainer = styled.div<StyledProps>`
  ${({theme}) => css`
    width: 100%;
    ${minWidthMedia.tablet`
      width: calc(100% - ${TROPHY_SIZE}px - ${theme.spacing.two});
      ${({isTrophySelected}: StyledProps) => isTrophySelected && "display: none;"}
    `}
  `}
`

export default ComponentToHideOnExpandContainer
